import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5971cba9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Delete Account", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Your account and your data will be permanently deleted. You can downgrade to a free plan instead to keep it. ", -1))

import { ref } from 'vue'

import DeleteAccountPopup from '@/app/components/billing/DeleteAccountPopup.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoDeleteAccount',
  setup(__props) {

const popupCancel = ref<InstanceType<typeof DeleteAccountPopup> | null>(null)

function showPopup(): void {
  if (!popupCancel.value) {
    return
  }

  popupCancel.value.show()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("button", {
      class: "delete-account__btn btns btns--red",
      onClick: showPopup
    }, " Delete your account "),
    _createVNode(DeleteAccountPopup, {
      ref_key: "popupCancel",
      ref: popupCancel
    }, null, 512)
  ]))
}
}

})